module.exports = {
	"24088": {
		"url": "http://douglassandzook.com",
		"mUrl": "http://douglassandzook.com",
		"data": {
			"menu": [
				{
					"name": "Cremation",
					"url": "http://www.douglassandzook.com/cremation/",
					"mUrl": "http://www.douglassandzook.com/cremation/",
					"target": "_blank"
				},
				{
					"name": "Traditional Services",
					"url": "http://www.douglassandzook.com/traditional-services/",
					"mUrl": "http://www.douglassandzook.com/traditional-services/",
					"target": "_blank"
				},
				{
					"name": "Forms",
					"url": "http://www.douglassandzook.com/forms/",
					"mUrl": "http://www.douglassandzook.com/forms/",
					"target": "_blank"
				},
				{
					"name": "About Us",
					"url": "http://www.douglassandzook.com/about-us/",
					"mUrl": "http://www.douglassandzook.com/about-us/",
					"target": "_blank"
				},
				{
					"name": "Legacy.com",
					"url": "https://www.legacy.com/",
					"mUrl": "https://www.legacy.com/",
					"target": "_self"
				},
				{
					"name": "Douglass & Zook",
					"url": "http://douglassandzook.com/",
					"mUrl": "http://douglassandzook.com/",
					"target": "_blank"
				}
			],
			"logo": {
				"alt": "Douglass & Zook",
				"src": "legacy/images/fhheader/24088headerlogo.png",
				"url": "http://douglassandzook.com/",
				"mUrl": "http://douglassandzook.com/",
				"target": "_blank"
			},
			"styles": {
				"backgroundColor": "#0e416b"
			}
		}
	},
	"default": {
		"url": "https://forestlawn.com",
		"mUrl": "https://forestlawn.com",
		"data": {
			"menu": [
				{
					"name": "Parks",
					"url": "https://forestlawn.com/locations/",
					"mUrl": "https://forestlawn.com/locations/",
					"target": "_blank"
				},
				{
					"name": "Making Arrangements",
					"url": "https://forestlawn.com/time-of-loss/",
					"mUrl": "https://forestlawn.com/time-of-loss/",
					"target": "_blank"
				},
				{
					"name": "About Us",
					"url": "https://forestlawn.com/our-team/",
					"mUrl": "https://forestlawn.com/our-team/",
					"target": "_blank"
				},
				{
					"name": "Museum & Events",
					"url": "https://forestlawn.com/events/",
					"mUrl": "https://forestlawn.com/events/",
					"target": "_blank"
				},
				{
					"name": "Contact",
					"url": "https://forestlawn.com/contact/",
					"mUrl": "https://forestlawn.com/contact/",
					"target": "_blank"
				},
				{
					"name": "Flowers",
					"type": "flowers",
					"url": "https://forestlawnflowershop.com/",
					"mUrl": "https://forestlawnflowershop.com/",
					"target": "_blank"
				},
				{
					"name": "Legacy.com",
					"url": "https://www.legacy.com/",
					"mUrl": "https://www.legacy.com/",
					"target": "_self"
				},
				{
					"name": "Forest Lawn",
					"url": "https://forestlawn.com/",
					"mUrl": "https://forestlawn.com/",
					"target": "_blank"
				}
			],
			"logo": {
				"alt": "Forest Lawn",
				"src": "legacy/images/fhheader/forestlawnheaderlogo.png",
				"url": "https://forestlawn.com/",
				"mUrl": "https://forestlawn.com/",
				"target": "_blank"
			}
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/reactModules/App/data/forestLawnHeader.json
// module id = 1238
// module chunks = 0